import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CondolenceHistory = () => {
  const navigate = useNavigate();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/condolence/check', { credentials: 'include' })
      .then(res => { if (!res.ok) navigate('/condolence'); })
      .catch(() => navigate('/condolence'));

    fetch('/api/condolence/applications', { credentials: 'include' })
      .then(res => res.json())
      .then(data => setApplications(data.applications || []))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [navigate]);

  const formatDate = (d) => {
    if (!d) return '-';
    const date = new Date(d);
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
  };

  return (
    <div className="form-page">
      <header className="form-header" style={{ background: '#37474f' }}>
        <button className="back-button" onClick={() => navigate('/condolence/menu')}>← 戻る</button>
        <h1>提出済みデータ確認</h1>
      </header>

      <main className="form-main">
        <div className="section-bar" style={{ background: '#eceff1' }}>
          <span className="icon">📋</span>
          <span className="title" style={{ color: '#37474f' }}>提出済みデータ一覧</span>
        </div>

        <div className="form-card">
          {loading ? (
            <p style={{ textAlign: 'center', color: '#666' }}>読み込み中...</p>
          ) : applications.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#666' }}>履歴がありません</p>
          ) : (
            <>
            <p style={{ fontSize: '13px', color: '#666', marginBottom: '12px' }}>※ 行をクリックすると内容の確認・訃報の発信・供花の発注ができます</p>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #37474f' }}>
                  <th style={thStyle}>申請日</th>
                  <th style={thStyle}>対象社員</th>
                  <th style={thStyle}>故人名</th>
                  <th style={thStyle}>続柄</th>
                  <th style={thStyle}>訃報</th>
                  <th style={thStyle}>弔電</th>
                  <th style={thStyle}>供花</th>
                </tr>
              </thead>
              <tbody>
                {applications.map(app => {
                  const isObituaryDeclined = app.send_obituary === '辞退する';
                  const isTelegramDeclined = app.request_telegram === '辞退する' || app.request_telegram === '辞退';
                  const isFlowerDeclined = app.request_flowers === '辞退する' || app.request_flowers === '辞退';

                  const renderStatus = (declined, done) => {
                    if (done) return <span style={{ color: '#2e7d32', fontWeight: '600' }}>済</span>;
                    if (declined) return <span style={{ color: '#666' }}>無</span>;
                    return <span style={{ color: '#c62828', fontWeight: '600' }}>必要</span>;
                  };

                  return (
                    <tr key={app.id}
                      style={{ borderBottom: '1px solid #eee', cursor: 'pointer' }}
                      onClick={() => navigate(`/condolence/create?id=${app.id}`)}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                      onMouseLeave={(e) => e.currentTarget.style.background = ''}
                    >
                      <td style={tdStyle}>{formatDate(app.application_date)}</td>
                      <td style={tdStyle}>{app.employee_name}</td>
                      <td style={tdStyle}>{app.deceased_name || '-'}</td>
                      <td style={tdStyle}>{app.relationship || '-'}</td>
                      <td style={tdStyle}>{renderStatus(isObituaryDeclined, app.obituary_sent)}</td>
                      <td style={tdStyle}>{renderStatus(isTelegramDeclined, app.telegram_ordered)}</td>
                      <td style={tdStyle}>{renderStatus(isFlowerDeclined, app.flower_ordered)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

const thStyle = {
  textAlign: 'left', padding: '12px 8px', color: '#37474f', fontSize: '14px', fontWeight: '600'
};
const tdStyle = {
  padding: '12px 8px', fontSize: '14px', color: '#333'
};

export default CondolenceHistory;
